import * as React from 'react';

import ModalWindowWithNoButtons from '../ModalWithNoButtons/ModalWindowWithNoButtons';

export interface SalesOrderModalProps {
  children: React.JSX.Element;
  title?: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function ContractNumbersModal(props: SalesOrderModalProps) {
  const { children, title, onClose, isOpen } = props;

  return (
    <ModalWindowWithNoButtons isOpen={isOpen} heading={title ?? ''} onClose={onClose}>
      {children}
    </ModalWindowWithNoButtons>
  );
}
